import { render, staticRenderFns } from "./important-information-select-organization.view.vue?vue&type=template&id=db3d24e8&"
import script from "./important-information-select-organization.view.vue?vue&type=script&lang=ts&"
export * from "./important-information-select-organization.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports